import projectRouteLinks from "./areas/projects/components/ProjectsRoutes/projectRouteLinks";
import tenantRouteLinks from "./areas/tenants/TenantsRoutes/tenantRouteLinks";
import libraryRouteLinks from "./areas/library/components/LibraryRoutes/libraryRouteLinks";
import infrastructureRouteLinks from "./areas/infrastructure/components/InfrastructureRoutes/infrastructureRouteLinks";
import taskRouteLinks from "./areas/tasks/components/TaskRoutes/taskRouteLinks";
import configurationRouteLinks from "./areas/configuration/components/ConfigurationRoutes/configurationRouteLinks";

export default {
    root: "/",
    ...projectRouteLinks(""),
    ...tenantRouteLinks(""),
    ...taskRouteLinks(""),
    release: (releaseId: string) => `/releases/${releaseId}`,
    library: libraryRouteLinks(""),
    infrastructure: infrastructureRouteLinks(""),
    configuration: configurationRouteLinks("")
};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/routeLinks.ts